function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u80CC\\u666F",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.2222222,12 C12.5481666,12 12,12.5481666 12,13.2222222 L12,21.7777778 C12,22.4518337 12.5481666,23 13.2222222,23 L21.7777778,23 C22.4518337,23 23,22.4518337 23,21.7777778 L23,13.2222222 C23,12.5481666 22.4518337,12 21.7777778,12 L13.2222222,12 Z",
  id: "basic-/-image_alt",
  fill: "#E89A4F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "basic-/-image_alt"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "basic-/-image_alt-(Background/Mask)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5,3 C3.89699996,3 3,3.89699996 3,5 L3,19 C3,20.1030006 3.89699996,21 5,21 L19,21 C20.1030006,21 21,20.1030006 21,19 L21,5 C21,3.89699996 20.1030006,3 19,3 L5,3 Z M5,5 L19,5 L19.0020008,19 L5,19 L5,5 Z",
  fill: "#FFFFFF",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18,6 L17.9998644,7.41486438 L7.41486438,17.9998644 L6,18 L5.99986438,16.5858644 L16.5858644,5.99986438 L18,6 Z M17.9998644,8.82786438 L17.9998644,11.6558644 L11.6558644,17.9998644 L8.82786438,17.9998644 L17.9998644,8.82786438 Z M17.9998644,13.0698644 L17.9998644,15.8978644 L15.8978644,17.9998644 L13.0698644,17.9998644 L17.9998644,13.0698644 Z M17.9998644,17.3128644 L18,18 L17.3128644,17.9998644 L17.9998644,17.3128644 Z M15.1708644,5.99986438 L5.99986438,15.1708644 L5.99986438,12.3428644 L12.3428644,5.99986438 L15.1708644,5.99986438 Z M10.9288644,5.99986438 L5.99986438,10.9288644 L5.99986438,8.10086438 L8.10086438,5.99986438 L10.9288644,5.99986438 Z M6.68686438,5.99986438 L5.99986438,6.68686438 L6,6 L6.68686438,5.99986438 Z",
  id: "\\u5408\\u4F75\\u5F62\\u72C0",
  fill: "#FFFFFF",
  mask: "url(#mask-2)"
})));

function SvgSidebarBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u80CC\u666F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBackground);
export default __webpack_public_path__ + "static/media/sidebar_background.f3b48a1c.svg";
export { ForwardRef as ReactComponent };